import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useText } from "../../context/ContentContext";

export default function Footer() {
  const { t } = useTranslation();
  const tagline = useText("footer_tagline", "footer.tagline");
  return (
    <footer data-testid="site-footer" className="bg-[#0a0a0b] border-t border-white/10 mt-24">
      <div className="max-w-[1500px] mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="font-serif text-2xl text-[#F5F5F0] mb-3">Maison Afra</div>
          <p className="text-sm text-[#A3A39D] leading-relaxed">{tagline}</p>
        </div>

        <div>
          <div className="overline mb-5">{t("footer.boutique")}</div>
          <ul className="space-y-3 text-sm text-[#A3A39D]">
            <li><Link to="/categorie/meubles" className="hover:text-[#D4AF37]">{t("nav.furniture")}</Link></li>
            <li><Link to="/categorie/bijoux" className="hover:text-[#D4AF37]">{t("nav.jewelry")}</Link></li>
            <li><Link to="/categorie/artisanat" className="hover:text-[#D4AF37]">{t("nav.crafts")}</Link></li>
            <li><Link to="/categorie/decoration" className="hover:text-[#D4AF37]">{t("nav.decoration")}</Link></li>
            <li><Link to="/revue" className="hover:text-[#D4AF37]">{t("nav.revue")}</Link></li>
            <li><Link to="/vip" className="hover:text-[#D4AF37]">{t("nav.vip")}</Link></li>
          </ul>
        </div>

        <div>
          <div className="overline mb-5">{t("footer.house")}</div>
          <ul className="space-y-3 text-sm text-[#A3A39D]">
            <li><Link to="/maison" className="hover:text-[#D4AF37]">{t("footer.our_story")}</Link></li>
            <li><Link to="/contact" className="hover:text-[#D4AF37]">{t("footer.contact")}</Link></li>
            <li><Link to="/login" className="hover:text-[#D4AF37]">{t("footer.client_space")}</Link></li>
            <li><Link to="/admin/login" className="hover:text-[#D4AF37]">{t("nav.admin")}</Link></li>
          </ul>
        </div>

        <div>
          <div className="overline mb-5">{t("footer.concierge")}</div>
          <p className="text-sm text-[#A3A39D] leading-relaxed" data-testid="footer-address">
            <span className="text-[#F5F5F0]">MAISON AFRA</span><br />
            MOUHA LIVRAISON<br />
            53 rue Léonard de Vinci<br />
            59100 ROUBAIX<br /><br />
            info@maisonafra.fr<br />
            +33 1 45 00 00 00
          </p>
          <p className="text-[10px] text-[#A3A39D] tracking-[0.18em] uppercase mt-4" data-testid="footer-siret">
            SIRET&nbsp;: 927 618 348 00019
          </p>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1500px] mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row justify-between items-center gap-3">
          <div className="text-xs text-[#A3A39D] tracking-[0.15em]">
            © {new Date().getFullYear()} MAISON AFRA — {t("footer.rights")}
          </div>
          <div className="overline text-[10px]">
            Roubaix · Paris · Abidjan
          </div>
        </div>
      </div>
    </footer>
  );
}
